// import external modules
import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import API from '../utils/API';
import TopLevelNavLink2 from '../components/nav/topLevelNavLink2';
import SystemToolbar from '../components/nav/systemToolbar';
import BookingPage from '../views/booking/bookingPage';
import LoadingWizard from '../components/spinner/wizard';

const getBookingNavigation = (isPublished) => [
    {
        adminOnly: false,
        name: 'Booking Page',
        icon: <i className="lab la-wpforms" />,
        section: 'form',
    },
    {
        adminOnly: false,
        name: 'Calendars',
        icon: <i className="las la-calendar-day" />,
        section: 'calendars',
    },
    {
        adminOnly: false,
        name: 'Registrants',
        icon: <i className="las la-users" />,
        section: 'registrants',
    },
    {
        adminOnly: false,
        name: 'Emails',
        icon: <i className="las la-envelope" />,
        section: 'emails',
    },
    {
        adminOnly: false,
        name: 'Publish Page',
        icon: <i className="las la-rocket" />,
        section: 'publish',
    },
    {
        adminOnly: false,
        name: 'Requests',
        icon: <i className="las la-clipboard-list" />,
        section: 'requests',
    }
];

class BookingPageLayout extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            orgId: this.props.match.params.organization,
            bookingPageId: this.props.match.params.bookingPage,
            bookingPage: {},
            bookingNavigation: getBookingNavigation(false),
            loading: true,
        };
    }

    async componentDidMount() {
        const { orgId, bookingPageId } = this.state;
        API()
            .get(`Organizations/${orgId}/bookingPages/${bookingPageId}`)
            .then((res) => {
                if (res.data) {
                    this.setState({ bookingPage: res.data, loading: false, bookingNavigation: getBookingNavigation(res.data.page.published) });
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ loading: false });
            });
    }

    render() {
        const { organizations, permission, organization, socket, platformNotifications } = this.props;
        const { orgId, bookingPageId, bookingPage, loading, bookingNavigation } = this.state;
        return (
            <div className='application'>
                <div className="topLevelPages">
                    <div className='systemContentContainer'>
                        <SystemToolbar
                            socket={socket}
                            displayLogo={true}
                            account={this.props.account}
                            organization={organization}
                            organizations={organizations}
                            logout={this.props.logout}
                            programsAvailable={this.props.programsAvailable}
                            subscriptionAddons={this.props.subscriptionAddons}
                            permission={this.props.permission}
                            subscriptionType={this.props.subscriptionType}
                            taskCount={this.state.taskCount}
                            updateTaskCount={this.props.updateTaskCount}
                            pingServer={this.props.pingServer}
                            platformNotifications={platformNotifications}
                            markNotificationAsRead={this.props.markNotificationAsRead}
                        />
                        <div className='flex' style={{ height: 'calc(100% - 55px)' }}>
                            <div className={`sideNavigation ${loading ? 'closed' : ''}`}>
                                <div className='sideMenuContainer overview'>
                                    <Link to={`/${orgId}/booking/${bookingPageId}/form`} className='menutItemLink' >
                                        <div className='p-30 pt-15 pb-0 pr-20 pb-20 '>
                                            <h3 className='sideEventName'>{bookingPage.name || 'Booking Page'}</h3>
                                            <p className='small'>{bookingPage.description || 'Loading booking page...'}</p>

                                        </div>
                                        <i className='las la-angle-right'></i>
                                    </Link>
                                    <hr className='m-20 mt-0 mr-0 ml-0' />

                                    <h5 className='mb-10 sideNaveColor'>Manage</h5>
                                    {bookingNavigation.map((menuItem, index) => {
                                        return (permission || !menuItem.adminOnly) ? (
                                            <TopLevelNavLink2
                                                isLast={index === bookingNavigation.length - 1}
                                                orgId={orgId}
                                                menuItem={menuItem}
                                                prefix={`/${orgId}/booking/${bookingPageId}`}
                                                index={index}
                                                permission={permission}
                                                key={`booking-nav-${index}`}
                                                id={menuItem.section}
                                            />
                                        ) : null;
                                    })}
                                    {bookingPage.isPartofEvent && bookingPage.eventId && (<><hr className='m-20 mt-auto mr-0 ml-0' />
                                    <Link to={`/${orgId}/events/${bookingPage.eventId._id}/overview`} className='menutItemLink' >
                                        <div className='p-30 pt-0 pb-0 pr-20 pb-20 '>
                                                <h5 className='sideNaveColor m-0'>Connected Event</h5>
                                                <h3 className='sideEventName mt-5'>{bookingPage.eventId.name}</h3>
                                                <p className='small mb-10'>Happening {bookingPage.eventId.startDate ? new Date(bookingPage.eventId.startDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : ''}</p>
                                        </div>
                                        <i className='las la-angle-right'></i>
                                    </Link></>)}
                                    {/* <button className='mt-a outline mb-20 ml-30 minWidth' onClick={() => window.open(`${window.location.origin}/${orgId}/book/${bookingPageId}`, '_blank')}>
                                        <i className='las la-link mr-10' /> Visit Page
                                    </button> */}
                                </div>
                            </div>

                            {!loading && (
                                <BookingPage
                                    orgId={orgId}
                                    account={this.props.account}
                                    organization={organization}
                                    socket={this.props.socket}
                                    sideMenuItems={bookingNavigation}
                                />
                            )}
                            {loading && (
                                <div className='pageContainer'>
                                    <LoadingWizard text="LOADING BOOKING PAGE" loading={loading} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(BookingPageLayout);
